import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd, IoIosSave } from 'react-icons/io'
import { useDispatch, useSelector } from 'react-redux'
import Loader from '../../components/Loader'
import { useState } from 'react'
import Modal from './Modal'
import CopyScheduleModal from './CopyScheduleModal'
import { setPage, getPeriodsList, deletePeriod, getCurrentPeriod } from '../../actions/periods'
import Table from '../../components/Table'
import { getSchoolYears, getShifts } from '../../actions/common'
import { Select } from '../../components/ModalInputs'
import Confirmation from '../../components/Confirmation/Confirmation'
import { BiTrash } from 'react-icons/bi'
import { getCurrentYearUtils } from '../../utils/classBook'
import { createNotification } from '../../components/Notifications/Notifications'


export default function Periods() {

  const dispatch = useDispatch()
  const { list, loading, currentPeriod } = useSelector(state => state.periods)

  const { shifts = [] } = useSelector(state => state.common)

  const [selectedItem, setSelectedItem] = useState(null)
  const { schoolYears } = useSelector(state => state.common)

  const [search, setSearch] = useState(null)
  const [periodForDelete, setPeriodForDelete] = useState(null)
  const [copyScheduleData, setCopyScheduleData] = useState(null)

  useEffect(() => {
    dispatch(getSchoolYears())
    dispatch(getShifts())
    // dispatch(getScClass())
  }, [])

  useEffect(() => {
    setSearch({ year: getCurrentYearUtils(schoolYears) || schoolYears?.[0]?.xp_key || '', shift: '0' })
  }, [schoolYears])

  useEffect(() => () => dispatch(setPage(0)), [])

  const handleSearch = (name, value) => {
    setSearch(prev => ({ ...prev, [name]: value }));
  }

  useEffect(() => {
    if (search !== null && search.year) dispatch(getPeriodsList({ year: search.year, shift: search.shift }));
  }, [search]);

  const openModal = (data) => () => {
    setSelectedItem(data || {})
    if (data?.lid) dispatch(getCurrentPeriod(data.lid))
  }

  const openCopyScheduleModal = () => {
    if (list?.length) {
      setCopyScheduleData(search)
    } else {
      createNotification('error', 'Нельзя скопировать пустой распорядок')
    }
  }

  const closeModal = () => {
    setSelectedItem(null)
  }

  const closeCopyScheduleModal = () => {
    setCopyScheduleData(null)
  }


  const yn = (value) => value ? 'Да' : 'Нет'

  const sortedList = useMemo(() => {
    if (!list) return list
    return [...list].sort((a, b) => {
      if (+a.s_year_id !== +b.s_year_id) return +a.s_year_id - +b.s_year_id
      return String(a.starttime).localeCompare(String(b.starttime))
    })
  }, [list])

  const renderRow = (data) => {
    const { name, s_year_id, starttime, stoptime, lid, status, dopstatus, outstatus, short_name, year_name, shift_name } = data
    return (
      <tr key={lid}>
        <td onClick={openModal(data)}>{name}</td>
        <td onClick={openModal(data)}>{starttime}</td>
        <td onClick={openModal(data)}>{stoptime}</td>
        <td onClick={openModal(data)}>{year_name}</td>
        <td onClick={openModal(data)}>{short_name}</td>
        <td onClick={openModal(data)}>{yn(status)}</td>
        <td onClick={openModal(data)}>{yn(dopstatus)}</td>
        <td onClick={openModal(data)}>{yn(outstatus)}</td>
        <td onClick={openModal(data)}>{shift_name}</td>
        <td><i className={styles.trash} onClick={deleteClickHandler({ lid, s_year_id, name, search })}><BiTrash /></i></td>
      </tr>
    )
  }

  const deleteClickHandler = (lid) => (e) => {
    e.stopPropagation()
    setPeriodForDelete(lid)
  }

  const acceptConfirm = async () => {
    const result = await dispatch(deletePeriod(periodForDelete))
    if (!result?.ok) createNotification('error', result?.message || 'Не удалось удалить период')
    setPeriodForDelete(null)
  }

  const rejectConfirm = () => {
    setPeriodForDelete(null)
  }

  return (
    <div className={styles.wrapper}>
      {periodForDelete &&
        <Confirmation
          title={`Вы уверены, что хотите удалить занятие ${periodForDelete.name}?`}
          acceptConfirmation={acceptConfirm}
          rejectConfirmation={rejectConfirm}
        />
      }
      <Modal
        closeModal={closeModal}
        data={selectedItem && (selectedItem.lid ? currentPeriod : selectedItem)}
        search={search}
        list={list}
      />
      <CopyScheduleModal
        open={!!copyScheduleData}
        closeModal={closeCopyScheduleModal}
        data={copyScheduleData}
      />
      <h1>Учебный распорядок</h1>

      <div className={styles.wrapperRow}>
        <div className={styles.selectWrapper}>
          <Select
            label={'Учебный год'}
            name={'year'}
            onChange={({ target: { name, value } }) => handleSearch(name, value)}
            value={search && search.year || schoolYears?.[0]?.xp_key}
          >
            {schoolYears?.map(el => <option key={el.xp_key} value={el.xp_key}>{el.name}</option>)}
          </Select>
        </div>
        <div className={styles.selectWrapper}>
          <Select
            label='Смена'
            name={'shift'}
            onChange={({ target: { name, value } }) => handleSearch(name, value)}
            value={search && search.shift || shifts?.[0]?.value}
          >
            {[{ name: 'Все', sid: '0' }, ...shifts]?.map(el => <option value={el.sid}>{el.name}</option>)}
          </Select>
        </div>
      </div>

      {loading
        ? <Loader />
        : list &&
        <div className={styles.tablePeriods} >
          <Table style={{ marginTop: '2rem', backgroundColor: 'white' }}>
            <thead>
              <tr className={styles.thead}>
                <th>Название</th>
                <th>Начало</th>
                <th>Окончание</th>
                <th>Учебный год</th>
                <th>Краткое название</th>
                <th>Учебный период</th>
                <th>Учебный период доп.</th>
                <th>Учебный период ВД</th>
                <th>Смена</th>
                <th />
              </tr>
            </thead>
            <tbody>
              {sortedList.map(renderRow)}
            </tbody>
          </Table>
        </div>
      }
      <div className={styles.buttons}>
        <Button icon={IoIosAdd} onClick={openModal()}><IoIosAdd size={30} />Добавить запись</Button>
        <Button icon={IoIosSave} onClick={openCopyScheduleModal}><IoIosSave size={30} />Копировать текущий распорядок</Button>
      </div>
    </div>
  )
}

